import API from "./index"

class FotoProdutoService {
  constructor() {
    this.path = `api/foto`
  }

  findAll({ page = 0, size = 10, filter = "" }) {
    page = page - 1 < 0 ? 0 : page - 1
    return API.get(this.path, { params: { page, size, filter } })
  }
  find() {
    return API.get(`${this.path}`)
  }
  findById(id) {
    return API.get(`${this.path}/${id}`)
  }
  async save(record) {
    if (record.get('id')) {
      return API.put(`${this.path}/${record.get('id')}`, record).then(
        ({ ...args }) => ({ created: false, ...args })
      );
    }

    return API.post(this.path, record).then(({ ...args }) => ({
      created: true,
      ...args,
    }));


  }
  remove(id) {
    if (!id) {
      throw new Error("ID cannot be null");
    }

    return API.delete(`${this.path}/${id}`);
  }
  alteraSituacao({ codFotoProduto, situacao }) {
    return API.put(`${this.path}/${codFotoProduto}/situacao`, { situacao }).then(
      ({ ...args }) => ({ created: false, ...args })
    );
  }
  findAllByIdAndParams(
    id,
    { page = 0, size = 10, nome = "", situacao = null }
  ) {
    const params = {
      page: page - 1 < 0 ? 0 : page - 1,
      size: size,
    }
    if (nome !== "") {
      params.nome = nome
    }
    if (situacao !== null) {
      params.situacao = situacao
    }
    return API.get(`${this.path}/${id}`, { params })
  }
}
export default FotoProdutoService
